export class ValidationLabelsGlossary {
    public static readonly REQUIRED = "Поле необходимо заполнить";
    public static readonly VALUE_INVALID = "Значение не валидно";
    public static readonly VALUE_EXISTS = "Значение уже присутсвует, необходимо заменить";
    public static readonly EMAILS_ARE_NOT_VALID = "Адреса дублируются или не валидны";
    public static readonly ANY_VALUES_INVALID = "Одно или несколько значений не валидны";
}
